app.factory('recipeInfo', function ($http, $q, serverConfig) {
    var _apiUrl = serverConfig.apiUrl;
    var _recipeInfo = null;
    var _enableList = null;
    return {
        categoryInfo : [
            { "id": "c00", "name": "すべて" },
            { "id": "c01", "name": "肉" },
            { "id": "c02", "name": "魚" },
            { "id": "c03", "name": "野菜" },
            { "id": "c04", "name": "米" },
            { "id": "c05", "name": "パン類" },
            { "id": "c06", "name": "麺" },
            { "id": "c07", "name": "その他" }
        ],
        getCategoryList : function () {
            return this.categoryInfo;
        },
        //DBからレシピ情報をロードし、recipeInfoへセットする
        loadRecipeList: function () {
            var deferred = $q.defer();
            if(_recipeInfo == null) {
                $http.post(_apiUrl+"/getRecipeInfo.php").then(function(response) {
                    _recipeInfo = [];
                    angular.forEach(response.data, function(record, i) {
                        _recipeInfo.push({
                            no : record.no,
                            contents : angular.fromJson(record.recipe_info) 
                        });
                    });
                    deferred.resolve(_recipeInfo);
                });
            }
            else {
                deferred.resolve(_recipeInfo);
            }
            return deferred.promise;
        },
        getRecipeList: function () {
            return _recipeInfo;
        },
        getRecipe: function (recipeid) {
            var idx = 0;
            for(var i=0; i<_recipeInfo.length; i++) {
                if(recipeid==parseInt(_recipeInfo[i].no)) {
                    idx = i;
                    break;
                }
            }
            return _recipeInfo[idx];
        },
        getEnableList: function( categoryInfo, recipeList ) {
            if( _enableList == null ) {
                var eList = [];
                for( var i = 0; i < categoryInfo.length; i++ ) {
                    var tp = [];
                    for( var j = 0; j < recipeList.length; j++ ) {
                        tp.push( recipeList[j].contents.category[i].belong );
                    }
                    eList.push( tp );
                }
                _enableList = eList;
            }
            return _enableList;
        }
    }
});
